import React from 'react'
import { Field } from 'redux-form'

import RgpdCoponent from 'components/Rgpd'
import { InputForm } from 'controls/Input'
import { TextAreaInputForm } from 'controls'
import Button from 'controls/Button'
import { companyConfig } from 'globalConfigApp'

import styles from './style'

const VipContactFormFields = ({ handleValidRgpd, checkedRgpd, invalid, errorMessageForm }) => (
  <div className="input-container">
    <Field
      name="fullName"
      id="full-name"
      component={InputForm}
      placeholder="Nombre(s) y Apellidos"
      label="Nombre(s) y Apellidos"
    />
    <Field
      className="form-input-margin"
      name="telephone"
      id="telephone"
      component={InputForm}
      placeholder="Teléfono"
      label="Teléfono"
    />
    <Field
      className="form-input-margin"
      name="email"
      id="email"
      component={InputForm}
      placeholder="Correo electrónico"
      label="Correo electrónico"
    />
    <Field
      className="form-input-margin"
      name="message"
      id="message"
      component={TextAreaInputForm}
      placeholder="Mensaje"
      label="Mensaje"
      rows={4}
    />
    <RgpdCoponent
      checkedRgpd={checkedRgpd}
      checkedRgpd
      handleValidRgpd={handleValidRgpd}
    />

    {errorMessageForm && (
      <p className="error-message-form">{errorMessageForm}</p>
    )}

    <section className="actions">
      <Button
        color="primary"
        fullWidth
        type="submit"
        className="submit"
        disabled={invalid && !checkedRgpd}
      >
        Solicitar información
      </Button>
      <p className="terms">
        Al hacer clic en “Solicitar información” estoy de acuerdo con los{' '}
        <span className="terms-link">
          <b>Términos y Condiciones</b>
        </span>{' '}
        de {companyConfig.name}.
      </p>
    </section>

    <style jsx>{styles}</style>
  </div>
)

export default VipContactFormFields